import { useAuthStore } from "../store";
import { Button } from "@/shared/components/Button";

export function SessionExpiredModal() {
  // Drive purely off the explicit `sessionExpired` flag set by forceLogout.
  // The old `user && !accessToken` heuristic fired during the bootstrap window
  // on every reload (persisted user hydrates synchronously, accessToken is
  // memory-only and lags behind the /refresh call).
  const sessionExpired = useAuthStore((s) => s.sessionExpired);

  if (!sessionExpired) return null;

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="session-expired-title"
      className="fixed inset-0 z-[var(--z-modal)] flex items-center justify-center bg-black/45 p-5"
    >
      <div className="w-full max-w-md rounded-lg border border-[var(--border)] bg-white shadow-[var(--shadow-2)]">
        <div className="border-b border-[var(--border)] px-5 py-4">
          <h2 id="session-expired-title" className="text-[16px] font-semibold text-gray-900">
            Session expired
          </h2>
        </div>
        <div className="px-5 py-4 text-[13px] text-gray-700">
          Your session has ended. Sign in again to continue.
        </div>
        <div className="flex justify-end gap-2 border-t border-[var(--border)] bg-[var(--bg-sunken)] px-5 py-3">
          <Button
            variant="primary"
            onClick={() => {
              window.location.href = "/login";
            }}
          >
            Sign in
          </Button>
        </div>
      </div>
    </div>
  );
}
